import { render } from "./AuditRevisions.vue?vue&type=template&id=74629ff4"
import script from "./AuditRevisions.vue?vue&type=script&lang=js"
export * from "./AuditRevisions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__